import React, { FunctionComponent } from 'react';
import { isParkPlusWebView } from 'core-lib/utils/source';
import { resetWebView } from 'core-lib/utils/common';
import { useAuth } from "auth/hooks/useAuth";
import { getLocalProfile } from "../utils/tokenStorage";
import { COOKIE } from "../types/Helper";
import { getCookieValue } from "../utils/cookie";

interface OwnProps {}

type Props = OwnProps;

const NativeAuthHandler: FunctionComponent<Props> = (props) => {
  const {setAuthData} = useAuth();
  const handleLogin = () => {
    const accessToken = getCookieValue(COOKIE.accessToken);
    const refreshToken = getCookieValue(COOKIE.refreshToken);
    const profile = getLocalProfile();
    if(accessToken && refreshToken && profile ){
      setAuthData({ accessToken,refreshToken,profile })
    }
  };
  const handleFailLogin = () => {
    if (isParkPlusWebView()) {
      resetWebView();
    }
  };

  return (
    <>
      <button
        onClick={handleLogin}
        id="native_login_btn"
        style={{ display: 'none' }}
      />
      <button
        onClick={handleFailLogin}
        id="native_login_fail_btn"
        style={{ display: 'none' }}
      />
    </>
  );
};
export default NativeAuthHandler;
